/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import styled, { css } from 'styled-components';
import {
  KOA_API_ENDPOINT,
  OPCO_CODE,
  LANG_CODE,
} from '../SectionAssessmentSurvey/SectionAssessmentBusinessGoals/SectionAssessmentBusinessGoals';
import Summarypage from './Summarypage';
import SectionAssessmentBanners from './SectionAssessmentBanners';
import RelatedArticles from '../../SectionSmartSearch/RelatedArticles';
import ShowError from '../ShowError';
import { mocksUrls } from '../__mocks__/AssesssmentService.mocks';
import {
  SectionAssessmentSummaryProps,
  RecommendationType,
  SummaryDataTypes,
} from '../Types/SectionAssessmentSummaryTypes';
import { LoadingSpinner } from '@legacy-vfuk/core-loading-spinner';
import { ErrorDataTypes } from '../Types/ShowError.types';
import twinxClient from '../../SectionSmartSearch/ProtectedApiClient';

const summaryPageOuter = css`
  min-height: 60vh;
`;

const LoadingSpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const constructSummaryNodeApi = (summarydata: SummaryDataTypes) => {
  const categories =
    summarydata?.interactionItem[0]?.item.characteristic[0]?.value?.categories;
  const subcategories =
    summarydata?.interactionItem[0]?.item.characteristic[0]?.value
      ?.sub_categories;
  const entitiesParent =
    summarydata?.interactionItem[0]?.item.characteristic[0]?.value?.entities;
  const entities = entitiesParent.map((item: any) => {
    return {
      nodeName: item.nodeName,
      maturitypercent: item.maturitypercent,
      attributes: item.children,
    };
  });

  return {
    category: categories,
    subcategory: subcategories,
    entities: entities,
  };
};

const SectionAssessmentSummary = ({
  content,
}: SectionAssessmentSummaryProps) => {
  const [tree, setTree]: any = useState({
    category: [],
    subcategory: [],
    entities: [],
  });
  const [businessName, setBusinessName] = useState<string>('');
  const [relatedSubcategory, setrelatedSubcategory] = useState<string>('');
  const [finalscore, setFinalScore] = useState<string>('');
  const [recommendation, setRecommendation] = useState<RecommendationType[]>(
    []
  );
  const [emailsurveyid, setEmailSurveyId] = useState<string>('');
  const [summaryPageLoader, setSummaryPageLoader] = useState<boolean>(true);
  const [twinid, setTwinId] = useState<string>('');
  const [summarypage, setSummaryPage] = useState<boolean>(false);
  const [error, setError] = useState<ErrorDataTypes | null>(null);

  const customParam = () => {
    getAssessmentAPI();
  };
  const getAssessmentAPI = async () => {
    if (window.history.state !== null) {
      setEmailSurveyId(window.history.state.emailsurveyid);
      setTwinId(window.history.state.twinid);
      setrelatedSubcategory(window.history.state.subcategory);
      setBusinessName(window.history.state.businessName);
    } else {
      setSummaryPageLoader(false);
      return navigate(content.assessmentSurveyPageSlug);
    }

    const query: any = {
      surveyid: window.history.state.twinid,
      get: 'recommendation',
      Opco: OPCO_CODE,
      Language: LANG_CODE,
    };
    const params = new URLSearchParams(query).toString();

    const url = KOA_API_ENDPOINT
      ? `${KOA_API_ENDPOINT}/assessment?${params}`
      : mocksUrls.SecTcsSumPage;

    try {
      const { data } = await twinxClient.get(url);

      if (!data?.result?.hasOwnProperty('code')) {
        handleConstructSummaryNodeApi(data.result);
        setRecommendation(
          data?.result?.interactionItem[0]?.item?.recommendationItem
        );
        const filterFinalScore =
          data.result.interactionItem[0].item.characteristic.filter(
            (obj: any) => {
              return obj.name === 'avg_maturity_percent';
            }
          );
        if (filterFinalScore.length > 0) {
          setFinalScore(filterFinalScore[0].value);
        } else {
          setFinalScore('0');
        }
        setSummaryPageLoader(false);
        setSummaryPage(true);
      } else {
        console.log('There is some problem in getting the recommendations');
        setSummaryPageLoader(false);
        setSummaryPage(false);
        setError({
          errorContent: content.serverError,
          errorType: 'serverError',
        });
      }
    } catch (error) {
      setSummaryPageLoader(false);
      setSummaryPage(false);
      console.log(error);
      if (!window.navigator.onLine) {
        setError({
          errorContent: content.noInternetError,
          errorType: 'noInternetError',
        });
      } else {
        setError({
          errorContent: content.serverError,
          errorType: 'serverError',
        });
      }
    }
  };

  const handleConstructSummaryNodeApi = (summarydata: any) => {
    const { category, subcategory, entities } =
      constructSummaryNodeApi(summarydata);
    setTree({
      category,
      subcategory,
      entities,
    });
  };

  useEffect(() => {
    getAssessmentAPI();
  }, []);

  const summaryPageResultsJSX = (
    <div css={summaryPageOuter}>
      <Summarypage
        content={content}
        businessName={businessName}
        finalscore={finalscore}
        tree={tree}
        recommendation={recommendation}
      />
      <SectionAssessmentBanners
        banners={content.assessmentSummaryPageBanners}
        passEmailSurveyId={emailsurveyid}
      />
      <RelatedArticles
        contentfulData={content.articlesSection}
        subCategory={relatedSubcategory}
        page={'assessment'}
      />
    </div>
  );

  const summaryPageLoaderJSX = (
    <LoadingSpinnerWrapper>
      <LoadingSpinner
        id="loader-id"
        dataSelectorPrefix="loader"
        appearance="secondary"
        size={5}
        dataAttributes={{
          'data-test-id': 'loader',
        }}
      />
    </LoadingSpinnerWrapper>
  );

  if (summaryPageLoader) {
    return summaryPageLoaderJSX;
  } else {
    if (summarypage) {
      return summaryPageResultsJSX;
    } else {
      return (
        error && (
          <ShowError
            errorContent={error.errorContent}
            errorType={error.errorType}
            customParam={customParam}
          />
        )
      );
    }
  }
};

export default SectionAssessmentSummary;
